module.exports = __webpack_public_path__ + "img/cadeado.b324f11a.svg";